import React from 'react';
import {Button, Card, Form, InputNumber, Typography} from "antd";
import BigNumber from "bignumber.js";
import utils from "../../common/utils";
import consts from "../../consts";
import FloatLabelNumberComponent from "../common/FloatLabelNumberComponent";
import {Translation} from "react-i18next";
import {debounce, find} from "lodash";
import LoadingSvg from "../common/LoadingSvg";
import ConfirmModal from '../modals/ConfirmModal';
import ModalAndLoadingAndValidateComponent from '../common/ModalValidateLoadingComponent';
import {object, number} from 'yup';
import BaseOrderComponent from "../common/BaseOrderComponent";

const {Text} = Typography;

class OrderStopLimit extends BaseOrderComponent {
  yupValidate = object().shape({
    stop_price: number().required().moreThan(0),
    price: number().required().moreThan(0),
    amount: number().required().moreThan(0),
    total: number().required().moreThan(0),
  });
  
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      params: {
        ...this.state.params,
        stop_price: 0,
      },
      // isVisible: false,
    }
    this.isBuy = this.isBuy.bind(this);
    this.getUserBalance = this.getUserBalance.bind(this);
  }
  
  componentWillReceiveProps(nextProps, nextContext) {
    // if (!!nextProps.isClickedOrderBookBuy) {
    //
    // }
  
    if (nextProps.coin !== this.props.coin || nextProps.currency !== this.props.currency) {
      // TODO: set last price
      this.handleMarketChange(nextProps);
    }
  
    if ((this.props.lastPrice !== nextProps.lastPrice) && !this.state.price) {
      this.setState({ params: { ...this.state.params, price: nextProps.lastPrice } });
    }
  }
  
  onStopPriceChange = (stopPrice, precision = consts.DEFAULT_PRECISION) => {
    if (new BigNumber(stopPrice).isNaN() || new BigNumber(stopPrice).dp(precision).isEqualTo(this.state.params.stop_price)) {
      this.setState({});
      return
    }
    
    this.setState({
      params: {
        ...this.state.params,
        stop_price: stopPrice
      }
    });
  }
  
  async validate() {
    let stop_price = number().optional();
    if (new BigNumber(this.state.params.price).isGreaterThan(0)) {
      stop_price = (
        this.isBuy() ?
          number().max(this.state.params.price, window.$t('validate.stop_less_than')).moreThan(0) :
          number().moreThan(this.state.params.price, window.$t('validate.stop_more_than')))
        .required().label(window.$t('stop_price'));
    }
    
    let balance = this.getUserBalance();
    let validAmount = number().required().moreThan(0).label(window.$t('amount'));
    let validTotal = number().required().moreThan(0).label(window.$t('total'));
    
    this.yupValidate = object().shape({
      stop_price,
      price: number().required().moreThan(0).label(window.$t('price_limit')),
      amount: this.isBuy() ? validAmount : validAmount.max(balance, window.$t('Balance insufficient')),
      total: this.isBuy() ? validTotal.max(balance, window.$t('Balance insufficient')) : validTotal,
    });
    
    return super.validate();
  }
  
  createBuyOrder = debounce(() => {
    this.hideModal();
    this.enLoading();
    this.props.onAddOrderAction({
      coin: this.props.coin,
      currency: this.props.currency,
      price: parseFloat(this.state.params.price),
      stop_price: parseFloat(this.state.params.stop_price),
      quantity: parseFloat(this.state.params.amount),
      trade_type: consts.ORDER_TRADE_TYPE_BUY,
      type: consts.ORDER_TYPE_STOP_LIMIT,
    }, () => {
      this.unLoading();
      this.clearOrder();
    });
  }, consts.DEFAULT_DURATION);
  
  createSellOrder = debounce(() => {
    this.hideModal();
    this.enLoading();
    this.props.onAddOrderAction({
      coin: this.props.coin,
      currency: this.props.currency,
      price: parseFloat(this.state.params.price),
      stop_price: parseFloat(this.state.params.stop_price),
      quantity: parseFloat(this.state.params.amount),
      trade_type: consts.ORDER_TRADE_TYPE_SELL,
      type: consts.ORDER_TYPE_STOP_LIMIT,
    }, () => {
      this.unLoading();
      this.clearOrder();
    });
  }, consts.DEFAULT_DURATION);
  
  isBuy() {
    return this.props.tradeType === window.c.ORDER_TRADE_TYPE_BUY_STR
  }
  
  getUserBalance() {
    return window._.get(this.props.user.userBalances[this.isBuy() ? this.props.currency : this.props.coin], 'available_balance', 0);
  }
  
  clearOrder = () => {
    this.setState({
      params: {
        price: 0,
        amount: 0,
        total: 0,
        stop_price: 0,
      }
    });
  }
  
  onSlide = (slideValue) => {
    if (this.isBuy()) {
      this.onTotalChange(new BigNumber(this.getUserBalance()).div(100).times(slideValue).toString(10));
    } else {
      this.onAmountChange(new BigNumber(this.getUserBalance()).div(100).times(slideValue).toString(10));
    }

    this.setState({ slideValue });
  }
  
  render() {
    const CacheSlider = this.renderSlider;
    
    const layout = {
      wrapperCol: {span: 24},
    };
    const tailLayout = {
      wrapperCol: {span: 24},
    };
    const upperCoin = `${this.props.coin}`.toUpperCase();
    const upperCurrency = `${this.props.currency}`.toUpperCase();
    
    const pricePrecision = utils.getPrecision(this.coinSetting?.precision || 0.00000001);
    const amountPrecision = utils.getPrecision(this.coinSetting?.minimum_quantity_precision || 0.00000001);
    const totalPrecision = utils.getPrecision(this.coinSetting?.minimum_amount_precision || 0.00000001);
    
    return (
      <Translation>
        {(t) => <div className="order-stop-limit-wrap">
          <Card className="order-card" loading={false}>
            <Form
              {...layout}
              name="basic"
              // initialValues={{ remember: true }}
              // onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
            >
              <div className="mb-medium" style={{color: "#76808F"}}>
                {t('exchange.order_stop_limit.available')}: {utils.formatCurrency(this.getUserBalance())} {this.isBuy() ? upperCurrency : upperCoin}
              </div>
              <Form.Item
                rules={[{required: true, message: t('exchange.order_stop_limit.stop_field_is_required')}]}>
                <FloatLabelNumberComponent
                  min={0}
                  customPrecision={pricePrecision}
                  name="stop"
                  label={t('exchange.order_stop_limit.stop')}
                  suffix={upperCurrency}
                  value={this.state.params.stop_price}
                  onChange={(v) => this.onStopPriceChange(v, pricePrecision)}
                  overrideFocus={this.clearErrors}
                />
                <div className="text-left p-abs ellipsis w-100" style={{color: "#76808F"}}
                     title={utils.upperCaseFirst(this.state.errors.stop_price || '')}>
                  <Text type='danger'>{utils.upperCaseFirst(this.state.errors.stop_price || '')}</Text>
                </div>
              </Form.Item>
              <Form.Item
                rules={[{required: true, message: t('exchange.order_stop_limit.limit_field_is_required')}]}>
                <FloatLabelNumberComponent min={0}
                                           name="price"
                                           customPrecision={pricePrecision}
                                           label={t('exchange.order_stop_limit.limit')}
                                           suffix={upperCurrency}
                                           value={this.state.params.price}
                                           onChange={(v) => this.onPriceChange(v, pricePrecision)}
                                           overrideFocus={this.clearErrors}
                />
                <div className="text-left p-abs no-wrap" title={utils.upperCaseFirst(this.state.errors.price || '')}>
                  <Text type='danger'>{utils.upperCaseFirst(this.state.errors.price || '')}</Text>
                </div>
              </Form.Item>
              
              <Form.Item
                rules={[{required: true, message: t('exchange.order_stop_limit.amount_field_is_required')}]}>
                <FloatLabelNumberComponent min={0}
                                           name="amount"
                                           customPrecision={amountPrecision}
                                           label={t('exchange.order_stop_limit.amount')}
                                           suffix={upperCoin}
                                           value={this.state.params.amount}
                                           onChange={(v) => this.onAmountChange(v, amountPrecision)}
                                           overrideFocus={this.clearErrors}
                />
                <div className="text-left p-abs no-wrap" title={utils.upperCaseFirst(this.state.errors.amount || '')}>
                  <Text type='danger'>{utils.upperCaseFirst(this.state.errors.amount || '')}</Text>
                </div>
              </Form.Item>
              <Form.Item
                rules={[{required: true, message: t('exchange.order_stop_limit.total_field_is_required')}]}
                style={{marginTop: 20}}>
                <FloatLabelNumberComponent min={0}
                                           name="total"
                                           customPrecision={totalPrecision}
                                           label={t('exchange.order_stop_limit.total')}
                                           suffix={upperCurrency}
                                           value={this.state.params.total}
                                           onChange={(v) => this.onTotalChange(v, totalPrecision)}
                                           overrideFocus={this.clearErrors}
                />
                <div className="text-left p-abs no-wrap" title={utils.upperCaseFirst(this.state.errors.total || '')}>
                  <Text type='danger'>{utils.upperCaseFirst(this.state.errors.total || '')}</Text>
                </div>
              </Form.Item>
  
              <CacheSlider slideValue={this.state.slideValue} />
  
              <Form.Item {...tailLayout}>
                {
                  this.isBuy() ?
                    <Button type="primary" htmlType="submit" onClick={this.showModal}
                            className={this.isBuy() ? 'bg-buy w-100' : 'bg-sell w-100'}
                            disabled={this.state.isLoading}
                            icon={<LoadingSvg name='bars' hidden={!this.state.isLoading} size={20}/>}
                    >
                      {!this.state.isLoading && `${t('exchange.order_stop_limit.buy')} ${upperCoin}`}
                    </Button> :
                    <Button type="primary" htmlType="submit" onClick={this.showModal}
                            className={this.isBuy() ? 'bg-buy w-100' : 'bg-sell w-100'}
                            disabled={this.state.isLoading}
                            icon={<LoadingSvg name='bars' hidden={!this.state.isLoading} size={20}/>}
                    >
                      {!this.state.isLoading && `${t('exchange.order_stop_limit.sell')} ${upperCoin}`}
                    </Button>
                }
              </Form.Item>
            </Form>
            
            <ConfirmModal
              title={t('common.notification')}
              okText={t('common.confirm')}
              okType={'primary'}
              cancelText={t('Cancel')}
              onConfirm={this.isBuy() ? this.createBuyOrder : this.createSellOrder}
              onCancel={this.hideModal}
              isVisible={this.state.isVisible}>
              <div>
                {t('exchange.order_confirm_question')}
              </div>
            </ConfirmModal>
          </Card>
        </div>}
      </Translation>
    );
  }
}

export default OrderStopLimit;
